export default __webpack_public_path__ + "static/media/mi.8e403b00.png";